import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {completeOrder, updateProductState,} from "../../redux/actions/Socket.Action";
import ApiConnect from "../../Utils/ApiConnect";

function OrderSlip(props) {
  const dispatch = useDispatch();
  const socketStatus = useSelector((state) => state.Socket.status);
  const CompleteOrder = (e, place, order) => {
    dispatch(completeOrder(place, order));
    if (!socketStatus) {
      e.innerHTML = "Order Complete...";
      ApiConnect.put(`POS/Orders/CompleteOrder?id=` + order)
        .then((response) => {
          // console.log(response);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const UpdateProductStatus = (e, place, product) => {
    dispatch(updateProductState(place, product));
    const cl = "strikeout";
    if (e.currentTarget.classList.contains(cl)) {
      e.currentTarget.classList.remove(cl);
    } else {
      e.currentTarget.classList.add(cl);
    }

    if (!socketStatus) {
      ApiConnect.put(`POS/Orders/ChangeProductStatus?id=` + product)
        .then((response) => {
          if (response.data.status === 200) {
            //  console.log(response);
          } else {
            console.log("Error from ${props.place} Product Status Update");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };
  const order = props.Orders;
  return (
    <>
      <div className="card">
        <header className={`card-header p-1 bg-` + order.color}>
          <h4 className="card-title text-white">
            <strong>{order.table}</strong>
            <small className="text-white"> {order.text}</small>
          </h4>
          <h5 className="card-title text-white">
            <strong>
              <small className="text-white">{order.order_time}</small>
            </strong>
          </h5>
        </header>
        <div className="card-body">
          <table className="table table-sm table-borderless p-0 border-0">
            <tbody>
              {order.product.map((product, prdin) => (
                <tr
                  className={product.status ? "strikeout" : ""}
                  onClick={(e) =>
                    UpdateProductStatus(e, props.place, product.id)
                  }
                  key={prdin}
                >
                  <td>{product.qty}</td>
                  <td>
                    {product.name}{" "}
                    {product.orderplace ? (
                      <span className="fs-16 material-icons-outlined text-warning">
                        delivery_dining
                      </span>
                    ) : (
                      <span className="fs-16 material-icons-outlined text-success">
                        dining
                      </span>
                    )}
                    <small>{product.note}</small>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <footer className="card-footer p-0">
          <button
            className="btn btn-square btn-small btn-success w-100 d-flex align-items-center p-1 fs-13"
            onClick={(e) => CompleteOrder(e.target, props.place, order.id)}
          >
            <span className="material-icons-outlined">done</span>Waiter:{" "}
            {order.waiter}
          </button>
        </footer>
      </div>
    </>
  );
}
export default React.memo(OrderSlip);
